export default "__VITE_ASSET__BuD_agkZ__"